import {Stack, Typography} from '@mui/material';
import {
  any,
  array,
  arrayOf,
  element,
  node,
  number,
  object,
  oneOfType,
  string,
} from 'prop-types';
import React from 'react';

const EmptyMessage = ({
  icon,
  children,
  title,
  description,
  actions = [],
  ...props
}) => {
  const Icon = icon
    ? React.cloneElement(icon, {
        color: icon.props?.color || 'action',
        sx: {
          ...icon.props?.sx,
          fontSize: icon.props?.sx?.fontSize || 48,
          marginBottom: 2,
        },
      })
    : undefined;

  return (
    <Stack
      {...props}
      sx={[
        {
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
          margin: 'auto',
          color: 'text.secondary',
          textAlign: 'center',
        },
        ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
      ]}
    >
      {Icon}
      <Typography
        variant="h6"
        sx={{
          marginBottom: description ? 2 : 0,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {title}
      </Typography>
      {description && (
        <Typography gutterBottom={!!children} sx={{color: 'text.secondary'}}>
          {description}
        </Typography>
      )}
      {children}
      {actions.length > 0 && (
        <Stack
          direction="row-reverse"
          spacing={1}
          sx={{
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            marginTop: 2,
          }}
        >
          {actions}
        </Stack>
      )}
    </Stack>
  );
};

EmptyMessage.propTypes = {
  icon: element,
  children: node,
  iconSize: number,
  title: any,
  description: string,
  actions: arrayOf(element),
  iconColor: string,
  sx: oneOfType([array, object]),
};

export default EmptyMessage;
